<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="formData">
    <div class="">
      <div class="form-half">
        <template v-if="formData.class_id === 14">
          <div class="form-item">
            <span>Will the vehicle be used for <strong>food</strong> delivery purpose?</span>
            <el-form-item
              :rules="rules.usage_ind"
              prop="form14.usage_ind">
              <v-radio-group
                v-model="formData.form14.usage_ind"
                :border="true"
                :list="allOptions.mc_usage" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Make</span>
            <el-form-item
              :rules="rules.brand_id"
              prop="form14.brand_id">
              <v-select
                v-model="formData.form14.brand_id"
                :list="allOptions.brand" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Body Type</span>
            <el-form-item
              :rules="rules.typ_of_bdy_id"
              prop="form14.typ_of_bdy_id">
              <v-select
                v-model="formData.form14.typ_of_bdy_id"
                :list="allOptions.typ_of_bdy" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Cylinder Capacity (Input "0" for EV)</span>
            <el-form-item
              :rules="rules.engn_cpcty"
              prop="form14.engn_cpcty">
              <v-input
                v-model="formData.form14.engn_cpcty"
                append="cc"/>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Year of Manufacture</span>
            <el-form-item
              :rules="rules.rgtn_yr"
              prop="form14.rgtn_yr">
              <v-select
                v-model="formData.form14.rgtn_yr"
                :list="allOptions.rgtn_yr" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>NCD</span>
            <el-form-item
              :rules="rules.ncd_pct"
              prop="form14.ncd_pct">
              <v-select
                v-model="formData.form14.ncd_pct"
                :list="allOptions.ncd" />
            </el-form-item>
          </div>
        </template>
        <template v-else-if="formData.class_id === 11">
          <h2>Insured Private Car </h2>
          <div class="form-item">
            <span>Make</span>
            <el-form-item
              :rules="rules.brand_id"
              prop="form11.brand_id">
              <v-select
                v-model="formData.form11.brand_id"
                :list="allOptions11.brand" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Model</span>
            <el-form-item
              :rules="rules.model_id"
              prop="form11.model_id">
              <v-select
                v-model="formData.form11.model_id"
                :list="carModelOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Body Type</span>
            <el-form-item
              :rules="rules.typ_of_bdy_id"
              prop="form11.typ_of_bdy_id">
              <v-select
                v-model="formData.form11.typ_of_bdy_id"
                :list="allOptions11.typ_of_bdy"
              />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Cylinder Capacity (Input "0" for EV)</span>
            <el-form-item
              :rules="rules.engn_cpcty"
              prop="form11.engn_cpcty">
              <v-input
                v-model="formData.form11.engn_cpcty"
                append="cc"/>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Year of Manufacture</span>
            <el-form-item
              :rules="rules.rgtn_yr"
              prop="form11.rgtn_yr">
              <v-select
                v-model="formData.form11.rgtn_yr"
                :list="allOptions11.rgtn_yr" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>NCD</span>
            <el-form-item
              :rules="rules.ncd_pct"
              prop="form11.ncd_pct">
              <v-select
                v-model="formData.form11.ncd_pct"
                :list="allOptions11.ncd" />
            </el-form-item>
          </div>
          <div v-show="showBenefits">
            <h2>More Benefits</h2>
            <v-checkbox-group
              v-model="formData.form11.benefits"
              :block="true"
              :list="form11Benefits" />
          </div>

        </template>
        <template v-else>
          <h2>Insured Commercial Vehicle</h2>
          <div class="form-item">
            <span>Vehicle Type</span>
            <el-form-item
              :rules="rules.typ_of_bdy_id"
              prop="form12.typ_of_bdy_id">
              <v-radio-group
                v-model="formData.form12.typ_of_bdy_id "
                :button="true"
                :list="allOptions12.tonnage" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Make</span>
            <el-form-item
              :rules="rules.brand_id"
              prop="form12.brand_id">
              <v-select
                v-model="formData.form12.brand_id"
                :list="allOptions12.brand" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Year of Manufacture</span>
            <el-form-item
              :rules="rules.rgtn_yr"
              prop="form12.rgtn_yr">
              <v-select
                v-model="formData.form12.rgtn_yr"
                :list="allOptions12.rgtn_yr" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>NCD</span>
            <el-form-item
              :rules="rules.ncd_pct"
              prop="form12.ncd_pct">
              <v-select
                v-model="formData.form12.ncd_pct"
                :list="allOptions12.ncd" />
            </el-form-item>
          </div>
          <div v-show="showBenefits">
            <h2>More Benefits</h2>
            <v-checkbox-group
              v-model="formData.form12.benefits"
              :block="true"
              :list="allOptions12.benefits" />
          </div>
        </template>
      </div>
      <div class="form-half">
        <template v-if="formData.class_id === 14">
          <h3>Coverage Detail</h3>
          <div class="form-item">
            <span>Coverage</span>
            <el-form-item
              :rules="rules.trm_of_cvr"
              prop="form14.trm_of_cvr">
              <v-radio-group
                v-model="formData.form14.trm_of_cvr"
                :disabledList="[0, 2]"
                :button="true"
                :list="allCoverTypeOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Named driver age</span>
            <el-form-item
              :rules="rules.dr_nm_drvr_age"
              prop="form14.dr_nm_drvr_age">
              <v-select
                v-model="formData.form14.dr_nm_drvr_age"
                :list="allOptions.dr_nm_drvr_age" />
            </el-form-item>
          </div>

          <div class="form-item">
            <span>Driving license of Car Owner</span>
            <el-form-item
              :rules="rules.dr_lic_of_own"
              prop="form14.dr_lic_of_own">
              <v-select
                v-model="formData.form14.dr_lic_of_own"
                :list="allOptions.dr_lic_of_own" />
            </el-form-item>
          </div>
        </template>
        <template v-else-if="formData.class_id === 11">
          <div class="form-item">
            <span>Coverage</span>
            <el-form-item
              :rules="rules.trm_of_cvr"
              prop="form11.trm_of_cvr">
              <v-radio-group
                v-model="formData.form11.trm_of_cvr"
                :button="true"
                :list="allCoverTypeOptions" />
            </el-form-item>
          </div>
          <div
            v-if="formData.form11.trm_of_cvr != 1"
            class="form-item">
            <span>Vehicle Market Value (Sum Insured)</span>
            <el-form-item
              :rules="rules.isrd_vl"
              prop="form11.isrd_vl">
              <v-input
                v-model="formData.form11.isrd_vl"
                prepend="HK$" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Number of Named Driver(s)</span>
            <el-form-item
              :rules="rules.no_of_nm_drvr"
              prop="form11.no_of_nm_drvr">
              <v-radio-group
                v-model="formData.form11.no_of_nm_drvr"
                :button="true"
                :list="numberFourOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Are all the driver(s) 31-60 years old?</span>
            <el-form-item
              :rules="rules.enough_age_ind"
              prop="form11.enough_age_ind">
              <v-radio-group
                v-model="formData.form11.enough_age_ind"
                :border="true"
                :list="yesNoOptionsDirver" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Are all the driver(s) having more than 2 years driving experience?</span>
            <el-form-item
              :rules="rules.enough_exp_ind"
              prop="form11.enough_exp_ind">
              <v-radio-group
                v-model="formData.form11.enough_exp_ind"
                :border="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>
        </template>
        <template v-else>
          <div class="form-item">
            <span>Coverage</span>
            <el-form-item
              :rules="rules.trm_of_cvr"
              prop="form12.trm_of_cvr">
              <v-radio-group
                v-model="formData.form12.trm_of_cvr"
                :button="true"
                :list="allCoverTypeOptions" />
            </el-form-item>
          </div>
          <div
            v-if="formData.form12.trm_of_cvr != 1"
            class="form-item">
            <span>Vehicle Market Value (Sum Insured)</span>
            <el-form-item
              :rules="rules.isrd_vl"
              prop="form12.isrd_vl">
              <v-input
                v-model="formData.form12.isrd_vl"
                prepend="HK$" />
            </el-form-item>
          </div>

          <div class="form-item">
            <span>Are all the driver(s) 25-65 years old?</span>
            <el-form-item
              :rules="rules.enough_age_ind"
              prop="form12.enough_age_ind">
              <v-radio-group
                v-model="formData.form12.enough_age_ind"
                :border="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Are all the driver(s) having more than 2 years driving experience?</span>
            <el-form-item
              :rules="rules.enough_exp_ind"
              prop="form12.enough_exp_ind">
              <v-radio-group
                v-model="formData.form12.enough_exp_ind"
                :border="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Will the insured vehicle be used for carrying goods for profit?</span>
            <el-form-item
              :rules="rules.use_carrying_profit_ind"
              prop="form12.use_carrying_profit_ind">
              <v-radio-group
                v-model="formData.form12.use_carrying_profit_ind"
                :border="true"
                :list="yesNoOptions" />
            </el-form-item>
          </div>
        </template>
      </div>
    </div>
  </el-form>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'QuickQuote',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        class_id: 14,
        form14: {
          trm_of_cvr: 1,
          brand_id: '',
          typ_of_bdy_id: '',
          engn_cpcty: '',
          rgtn_yr: '',
          ncd_pct: '',
          usage_ind: '',
          no_of_nm_drvr: 1,
          enough_age_ind: '',
          dr_nm_drvr_age: '',
          // enough_exp_ind: '',
          dr_lic_of_own: ''
        },
        form11: {
          brand_id: '',
          model_id: '',
          typ_of_bdy_id: '',
          engn_cpcty: '',
          rgtn_yr: '',
          ncd_pct: '',
          benefits: [],
          trm_of_cvr: 1,
          isrd_vl: '',
          no_of_nm_drvr: 1,
          enough_age_ind: '',
          enough_exp_ind: '',
        },
        form12: {
          brand_id: '',
          typ_of_bdy_id : '',
          rgtn_yr: '',
          ncd_pct: '',
          benefits: [],
          trm_of_cvr: 1,
          isrd_vl: '',
          no_of_nm_drvr: 1,
          enough_age_ind: '',
          enough_exp_ind: '',
          use_carrying_profit_ind: ''
        }
      },
    }
  },
  computed: {
    ...mapState('quote', [  'carModelOptions']),
    showBenefits() {
      if(this.formData.class_id === 11 && this.formData.form11.trm_of_cvr !== 1 ) {
        return true
      }
      if(this.formData.class_id === 12 && this.formData.form12.trm_of_cvr !== 1 ) {
        return true
      }
      return false
    },
    form11Benefits() {
      // let year = new Date().getFullYear()
      if(this.checkRgtnYr) {
        return this.allOptions11.benefits
      }
      return this.allOptions11.benefits.filter(item => {
        return item.id !== 2
      })
    },
    checkRgtnYr() {
      // 檢查是否兩年内
      // 不是兩年内的話 Benefits 需要隱藏 New For Old Cover In Year 1  選項
      let year = new Date().getFullYear()
      if(this.formData.form11.rgtn_yr) {
        return (year - this.formData.form11.rgtn_yr) < 2
      }
      return false
    }
  },
  watch: {
    'formData.form11.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val !== '' && val !== old) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(form) {
        if(form) {
          this.formData.class_id = this.form.class_id
          Object.assign(this.formData[`form${this.form.class_id}`], form)
        }
      }
    }
  },
  methods: {
    ...mapActions('quote', [ 'setQuoteResult', 'updateCarModelOptions']),
    submitForm(){
      this.$refs.form.validate(valid => {
        if(valid) {
          if(this.formData.class_id === 11) {
            // 處理 benefits
            const index = this.formData.form11.benefits.indexOf(2)
            if(index !== -1 && !this.checkRgtnYr) {
              this.formData.form11.benefits.splice(index, 1)
            }
          }
          let params = {
            class_id: this.formData.class_id,
            ...this.formData[`form${this.formData.class_id}`]
          }
          this.$emit('getFormData', {
            params
          })
        }
      })
    },
    handler() {
      return {
        checkData: data => {
          const filterData =  data.filter(item => {
            if(item.is_refer_case === 0 && item.is_error_case === 0) {
              return item
            }
          })
          return filterData.length > 0? true: false
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  padding-bottom: 100px;
  .pd-t {
    padding-top: 20px;
  }
}
</style>
